// extracted by mini-css-extract-plugin
export default {"dropdownButton":"og6FpsX2sypj7xrENUrn","moreAction":"yC25iMgH3DT8xQaaMGtv","backgroundWhite":"lCnIVKsz6BXobs4vaPFh"};